/**
 * Acciones sobre unidades de gestion
 * @type {string[]}
 */
UnidadGestionActionsService.$inject = ['$log', 'dialogService', '$http', 'dialogConfirmService', '$q'];
export default function UnidadGestionActionsService($log, dialogService, $http, dialogConfirmService, $q) {

    var urlTiposBase = Sigo.var.path + '/mantenimiento/unidad-gestion-acciones';

    const TEMPLATE_ADD_TIPO_DIALOG = require('./add-tipo/add-tipo-uni-ges-dialog.html');
    const ID_ADD_TIPO_DIALOG = 'dialog-add-tipo-uniges';

    const TEMPLATE_ADD_USER_DIALOG = require('./add-user/add-usr-uni-ges-dialog.html');
    const ID_ADD_USER_DIALOG = 'dialog-add-user-uniges';

    const TEMPLATE_ADD_ENT_DIALOG = require('./add-ent/add-ent-uni-ges-dialog.html');
    const ID_ADD_ENT_DIALOG = 'dialog-add-ent-uniges';

    var anyadirEntidadUniGes = function (idUniGes) {
        var titulo = 'Añadir entidad';
        return doDialog(ID_ADD_ENT_DIALOG, TEMPLATE_ADD_ENT_DIALOG, {idUniGes: idUniGes}, titulo);
    };

    var borrarEntidad = function (idUniGes, idEntidad) {
        var options = {title: 'Borrar entidad'};
        var urlGet = urlTiposBase + '/del-entidad/' + idUniGes + '/' + idEntidad;

        var deferred = $q.defer();

        dialogConfirmService
            .open('¿Estás seguro de que quieres borrar la entidad de la unidad de gestión?', options)
            .then(function () {
                var promise = $http.get(urlGet);
                promise.then(function (data) {
                    $.toast(data.data.toast);
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            });

        return deferred.promise;
    };

    var anyadirUsuarioUniGes = function (idUniGes) {
        var titulo = 'Añadir usuario';
        return doDialog(ID_ADD_USER_DIALOG, TEMPLATE_ADD_USER_DIALOG, {idUniGes: idUniGes}, titulo);
    };

    var borrarUsuario = function (idUniGes, idUsuario) {
        var options = {title: 'Borrar usuario'};
        var urlGet = urlTiposBase + '/del-usuario/' + idUniGes + '/' + idUsuario;

        var deferred = $q.defer();

        dialogConfirmService
            .open('¿Estás seguro de que quieres borrar al usuario de la unidad de gestión?', options)
            .then(function () {
                var promise = $http.get(urlGet);
                promise.then(function (data) {
                    $.toast(data.data.toast);
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            });

        return deferred.promise;
    };

    var activarDesactivarTipoUniGes = function (idUniGes, idTipo) {

        var fnError = function (mensaje) {
            $.toast({
                heading: ucfirst(Lang.choice('nombres.error', 1)),
                text: mensaje,
                showHideTransition: 'slide',
                hideAfter: 10000,
                icon: 'error'
            });
        };

        var deferred = $q.defer();

        $http.get(urlTiposBase + '/des-activar-tipo/' + idTipo)
            .success(function (data) {
                $.toast(data.toast);
                deferred.resolve();
            })
            .error(function (respuesta) {
                if (respuesta.error.message == 'mensajes.confirm_tipo_padre_con_hijos') {
                    var options = {
                        title: ucfirst(Lang.choice('nombres.desactivar', 1)) + " "
                        + Lang.choice('nombres.tipo_incidencia', 1),
                        botonOk: ucfirst(Lang.choice('nombres.desactivar', 1))
                    };

                    dialogConfirmService
                        .open(Lang.get(respuesta.error.message), options)
                        .then(function () {
                            var promise = $http.get(urlTiposBase + '/des-activar-tipo/' + idTipo + '/true');
                            promise.then(function (data) {
                                $.toast(data.data.toast);
                                deferred.resolve();
                            }, function () {
                                fnError(Lang.get(respuesta.error.message));
                                deferred.reject();
                            });
                        });
                } else {
                    fnError(Lang.get(respuesta.error.message));
                    deferred.reject();
                }
            });

        return deferred.promise;
    };

    var anyadirTipoUniGes = function (idUniGes) {
        var titulo = 'Añadir tipo';
        return doDialog(ID_ADD_TIPO_DIALOG, TEMPLATE_ADD_TIPO_DIALOG, {idUniGes: idUniGes}, titulo);

    };

    function doDialog(idDialog, template, datos, titulo) {
        var options = {autoOpen: false, modal: true, title: titulo, minWidth: 600};
        var opcionesExtra = {deshabilitarBotones: true};

        return dialogService.open(idDialog, template, datos, options, opcionesExtra);
    }


    return {
        anyadirEntidadUniGes: anyadirEntidadUniGes,
        borrarEntidad: borrarEntidad,
        anyadirUsuarioUniGes: anyadirUsuarioUniGes,
        borrarUsuario: borrarUsuario,
        activarDesactivarTipoUniGes: activarDesactivarTipoUniGes,
        anyadirTipoUniGes: anyadirTipoUniGes
    };
}
